/*
 * @Descripttion: 种草社区接口
 * @Author: Lu peng
 * @Date: 2022-12-05 17:16:44
 * @LastEditors: Lu peng
 * @LastEditTime: 2022-12-05 17:16:44
 */
import Http from "./../http";

export default {
  // 搜索发现
  searchLook(urlParams, params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/content/search/query", urlParams, params, res => {
      callback(res);
    })
  },
  // 搜索结果
  searchResultData(urlParams, params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/seeding/es/searchSeeding", urlParams, params, res => {
      callback(res);
    })
  },
  // 搜索结果点赞
  searchLike(urlParams, params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/seeding/eventContent", urlParams, params, res => {
      callback(res);
    })
  },
}